import { memo as Memo, useMemo, useState } from 'react';

//* Components
import BlogListItem from './BlogListItem';
import Filters from '@components/global/Filter';

//* Styles
import BlogListStyle from './style';


const BlogList = Memo(({ data }) => {
    //! States
    const [filterSelect, setFilterSelect] = useState('all');

    const changeFilterType = (currentTarget) => {
        setFilterSelect(currentTarget);
    };

    const filtersItem = useMemo(() => {
        let arr = [];

        const itemsArr = Object.values(data.items);

        for (let i = 0; i < itemsArr.length; i++) {
            const item = itemsArr[i];
            arr.push(item.fields.category);
        }

        return arr;
    }, [data.items]);

    //! Items
    const items = useMemo(() => {
        return Object.values(data.items).map((i, k) => {
            if (filterSelect === 'all' || filterSelect === i.fields.category) {
                return (
                    <BlogListItem
                        key={k}
                        createdAtr={i.fields}
                        url={`/blog/${i.fields.slug}/`}
                    />
                );
            }
        });
    }, [data, filterSelect]);

    return (
        <BlogListStyle>
            <Filters
                data={filtersItem}
                parentCallback={changeFilterType}
            />

            <section className={'blogItemWrap'}>{items}</section>
        </BlogListStyle>
    );
});

export default BlogList;
